import Contract from "./contract.view";

export default Contract;
